function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const ALL_AIRLINES = [
  {
    id: 1,
    name: 'Air India',
    country: 'India',
    image: 'https://images.pexels.com/photos/30002014/pexels-photo-30002014.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    hint: 'National carrier of India',
  },
  {
    id: 2,
    name: 'IndiGo',
    country: 'India',
    image: 'https://images.pexels.com/photos/34002439/pexels-photo-34002439.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    hint: 'India\'s largest airline by passengers',
  },
  {
    id: 3,
    name: 'SpiceJet',
    country: 'India',
    image: 'https://images.pexels.com/photos/13411556/pexels-photo-13411556.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    hint: 'Indian low-cost carrier with red livery',
  },
  {
    id: 4,
    name: 'Emirates',
    country: 'UAE',
    image: 'https://images.pexels.com/photos/33837105/pexels-photo-33837105.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    hint: 'Major airline from Dubai',
  },
  {
    id: 5,
    name: 'Singapore Airlines',
    country: 'Singapore',
    image: 'https://images.unsplash.com/photo-1740495328295-1e7f4f560c0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxTaW5nYXBvcmUlMjBBaXJsaW5lcyUyMGFpcnBsYW5lJTIwZmx5aW5nfGVufDB8fHx8MTc3OTI2MzIxNnww&ixlib=rb-4.1.0&q=85',
    hint: 'Known for world-class service from Southeast Asia',
  },
  {
    id: 6,
    name: 'British Airways',
    country: 'United Kingdom',
    image: 'https://images.pexels.com/photos/28344568/pexels-photo-28344568.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    hint: 'Flag carrier of the United Kingdom',
  },
  {
    id: 7,
    name: 'Qatar Airways',
    country: 'Qatar',
    image: 'https://images.unsplash.com/photo-1631540710044-eba1ee07223e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxRYXRhciUyMEFpcndheXMlMjBhaXJwbGFuZXxlbnwwfHx8fDE3NzkyNjMyMTZ8MA&ixlib=rb-4.1.0&q=85',
    hint: 'World\'s best airline from the Middle East',
  },
  {
    id: 8,
    name: 'Lufthansa',
    country: 'Germany',
    image: 'https://images.pexels.com/photos/28704794/pexels-photo-28704794.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    hint: 'Largest German airline with a crane logo',
  },
  {
    id: 9,
    name: 'Turkish Airlines',
    country: 'Turkey',
    image: 'https://images.pexels.com/photos/10799288/pexels-photo-10799288.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    hint: 'Flies to more countries than any other airline',
  },
  {
    id: 10,
    name: 'Air India Express',
    country: 'India',
    image: 'https://images.unsplash.com/photo-1761203632753-976368cb66b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxBaXIlMjBJbmRpYSUyMGFpcmxpbmUlMjBsb2dvfGVufDB8fHx8MTc3OTI2MzE5MXww&ixlib=rb-4.1.0&q=85',
    hint: 'Low-cost arm of India\'s national carrier',
  },
];

function getDistractors(correct, all, count = 3) {
  const others = all.filter((a) => a.id !== correct.id);
  return shuffle(others).slice(0, count);
}

export function getAirlineQuestions(count = 10) {
  const selected = shuffle(ALL_AIRLINES).slice(0, Math.min(count, ALL_AIRLINES.length));

  return selected.map((airline) => {
    const distractors = getDistractors(airline, ALL_AIRLINES, 3);
    const options = shuffle([airline, ...distractors]);
    const correctIndex = options.findIndex((o) => o.id === airline.id);

    return {
      id: airline.id,
      image: airline.image,
      hint: airline.hint,
      country: airline.country,
      answer: airline.name,
      options: options.map((o) => o.name),
      correctIndex,
    };
  });
}
